import { connect } from "react-redux";
import EmpFullfillmentForm from "./EmpFullfillmentForm";
import { bindActionCreators } from "redux";
import {viewEmpMrfMaterial,saveEmpMrfSerialNo} from "../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
  materialData: state.MaterialRequistionForm.empMrfMaterial,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      viewEmpMrfMaterial,
      saveEmpMrfSerialNo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmpFullfillmentForm);
